/* istanbul ignore next */
(function(angular) {
  'use strict';

  angular.module('core.directives', ['core.services']);

  angular.module('core', [
    /* fileblock:debug modules */
    /* endfileblock */
    'ngTouch',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',
    'ui.router',
    'ui.bootstrap',
    'ui.bootstrap.modal',
    'angularFileUpload',
    'fef',
    'bento.modern',
    'bento-fm.core',
    'tmh.dynamicLocale',
    'bmTranslateEventUtils',
    'bluemoon.components',
    'bm.userPreferences',
    'bluemoon.components.NavigationUtils',
    'bluemoon.components.bluemoonForceDesktop',
    'bluemoon.components.analytics',
    'bmClientAppHeader',
    'bmClientAppNav',
    'bmClientAppMain',
    'bluemoon.error.logging',
    'onvio.nav.staffNav',
    'bmPermissionGroup',
    'bmPermissionGroupsData',
    'bmPermissionGroupsDetail',
    'bmPermissionGroupsList',
    'bm.permissiongroups.PermissionGroupsPicker',
    'bmPermissionGroupsPicker',
    'bmPermissionGroupsEquation',
    'bmPermissionGroupsMembersGrid',
    'bmPermissionGroupsMembers',
    'permissionGroupsMembers',
    'onvio.setup',
    'bm.optionalheader',
    'bm.practice.timeAndExpense',
    'bm.practice.billing',
    'bm.practice.receiptAndAdjustment',
    'bm.practice.timeAndExpense.Timer',
    'bm.practice.widgets',
    // 'onvio.projects.list',
    'nucleus.dashboard',
    'accountingCosts',
    'onvio.documents',
    'bluemoon.dms.utility.routing',
    'templates-main',
    'angularSpectrumColorpicker',
    'bmFroala',
    'onvio.clientDashboard',
    'onvio.firmDashboard',
    'onvio.common.privacyFooter',
    'onvio.common.privacyFooterContent',
    'onvio.reports',
    'setup-module',
    'onvio.test',
    'nucleus.dashboard.bmOverviewWidget',
    'bmpAutocompleteBmOff',
    'onvio.setup.customFieldsSetup'
  ])

  .config([
    '$locationProvider',
    '$translateProvider',
    '$translatePartialLoaderProvider',
    'tmhDynamicLocaleProvider',

    function(
      $locationProvider,
      $translateProvider,
      $translatePartialLoaderProvider,
      tmhDynamicLocaleProvider
    ) {
      // Revert to pre-Angular 1.6 behavior, see
      // https://docs.angularjs.org/guide/migration#commit-aa077e8
      $locationProvider.hashPrefix('');

      $translateProvider.useLoader('$translatePartialLoader', {
        urlTemplate: '{part}/{lang}.json'
          //,loadFailureHandler: 'i18nPartialLoaderErrorHandler'
      });

      // load app translations
      $translatePartialLoaderProvider.addPart('i18n');

      // Add MessageFormat as an optional interpolation type for Angular Translate
      $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

      // choose sanitization strategy
      $translateProvider.useSanitizeValueStrategy('escapeParameters');

      tmhDynamicLocaleProvider.localeLocationPattern('node_modules/angular-i18n/angular-locale_{{locale}}.js');
    }
  ])

  // Setting both these baseTemplateUrls to empty string,
  // because we are using html2js for all templates and
  // no base pathing is required.
  .value('fef.baseTemplateUrl', '')
    .value('bluemoon.components.baseTemplateUrl', '')

  .run([
      '$log',
      '$timeout',
      '$document',
      '$window',
      '$rootScope',
      '$bentoTranslate',
      'languageStorageManager',
      '$anchorScroll',
      'tmhDynamicLocale',
      '$analytics',
      function(
        $log,
        $timeout,
        $document,
        $window,
        $rootScope,
        $bentoTranslate,
        languageStorageManager,
        $anchorScroll,
        tmhDynamicLocale,
        $analytics) {

        var setMomentLocale = function(lang) {
          // en is the fallback for momentjs, en = en-US.
          $window.moment.locale([lang, 'en']);
        };

        var setGlobalizeLocale = function(lang) {
          if ($window.bmp && $window.bmp.globalize && $window.bmp.globalize.CultureInfo) {
            $window.bmp.globalize.CultureInfo.locale(lang);
          }
        };

        const wijmo = $window.wijmo;
          if (wijmo) {

            wijmo.angular.WjLink.prototype._siblingInserted = function(e) {
              const currentElement = this.tElement[0];
              for (let r = 0; r < e.length; r++) {
                const mutation = e[r];
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                  const isElementAdded = Array.from(mutation.addedNodes).some(node => node === currentElement);
                  if (isElementAdded) {
                    const currentIndex = this._getIndex();
                    const control = this.control;
                    const parentControls = this.parent.control[this._getParentProp()];
                    const existingIndex = parentControls.indexOf(control);
                    if (currentIndex >= 0 && existingIndex >= 0 && currentIndex !== existingIndex) {
                      parentControls.splice(existingIndex, 1);
                      parentControls.splice(Math.min(currentIndex, parentControls.length), 0, control);
                    }
                  }
                }
              }
            };
        }

        var loadBentoTranslations = function(lang) {
          // Don't try to load lang files for en-* since they are hardcoded in JS
          if (/^en-/.test(lang)) {
            $bentoTranslate.setTranslation({});
          } else {
            $bentoTranslate.load('node_modules/bluemoon-bento-modern-translations/' + lang + '.json');
          }
        };

        var loadAngularApplicationLocale = function(lang) {
            window.dispatchEvent(new CustomEvent('bm-application-language-change', { detail: lang }));
        };

        var loadAngularLocale = function(lang) {
          tmhDynamicLocale.set(lang.toLowerCase());
        };

        var startupLang = languageStorageManager.get();

        function updateThirdPartyLibsLocale(locale) {
          setMomentLocale(locale);
          setGlobalizeLocale(locale);
          loadBentoTranslations(locale);
          loadAngularLocale(locale);
          loadAngularApplicationLocale(locale);
        }

        updateThirdPartyLibsLocale(startupLang);

        $rootScope.$on('bmLanguageChangeSuccess', function(event, changeArgs) {
          if (changeArgs.language !== startupLang) {
            updateThirdPartyLibsLocale(changeArgs.language);
          }
        });

        // Staff has some views that are not good at handling lang change
        // short of a full refresh. The regular bmLanguageChangeSuccess
        // event cannot be used as it fires after retrieving user preferred lang
        // from the server. So we refresh only in the case of a user changing
        // their preferred language.
        $rootScope.$on('bmLanguageChangeByUserSuccess', function() {
          $window.location.reload();
        });

        // Set app name (non-localized) for analytics
        $analytics.setSuperProperties({
          'app': 'Onvio Center'
        });

        $rootScope.$on('$stateNotFound', function(event, toState) {
          $log.error('----');
          $log.error('$stateNotFound:');
          if (toState) {
            $log.error(JSON.stringify(toState));
          }
        });

        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
          $log.error('----');
          $log.error('$stateChangeError');
          if (toState) {
            $log.error(JSON.stringify(toState));
          }
          $log.error(error);
        });

        // setup scroll top event
        $rootScope.$on('scollViewTop', function() {
          $timeout(function() {
            $anchorScroll('mainView');
            $window.scrollTo(0, 0);
          }, 1);
        });
      }
    ]) // jshint ignore:line

}(window.angular));
